import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueCompositionAPI from '@vue/composition-api';
import { createPinia, PiniaVuePlugin } from 'pinia';
import piniaPersist from 'pinia-plugin-persist';

import i18n from '@/plugins/vue-i18n';

import '@/sass/custom_v2.scss';
import '@/sass/custom.scss';
import 'bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';

import { worker } from '@/mocks/browser';
import * as config from '@/config';

if (!config.EXTERNAL_CONNECTION) {
  worker.start({
    onUnhandledRequest: 'bypass',
  });
  console.log(`通信モック(Mock Service Worker : MSW)を起動しました`);
}

// LoadingChunkFailed系のエラー など ハンドリングされていない例外が発生した場合、リロードさせる
window.addEventListener('error', (e) => {
  if (/Loading chunk [\d]+ failed/.test(e.message)) {
    window.location.reload();
  }
});

export const pinia = createPinia();
pinia.use(piniaPersist);
Vue.use(VueCompositionAPI);
Vue.use(PiniaVuePlugin);

Vue.config.productionTip = false;

new Vue({
  router,
  pinia,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
